import React from 'react';
import { NavHomeButton, NavText } from './navStyles';
import { useNavRouting } from './useNavRouting';
import { NavItem } from '../../config/navigationConfig.types';
import { navIconMap } from './navIconMap';
import { NavIconImage } from './NavIconImage';
import { useApplicationContext } from '../../context/ApplicationContext';
import { useActiveNavItem } from '../../hooks/useActiveNavItem';
import { NAV_HOVER_BG_MAIN } from './navConstants';

interface NavHomeButtonComponentProps {
  item: NavItem;
  isNavOpen: boolean;
}

export const NavHomeButtonComponent: React.FC<NavHomeButtonComponentProps> = ({ item, isNavOpen }) => {
  const { navigate } = useNavRouting();
  const { activeNavItemId, filteredNavigation } = useApplicationContext();
  const { getActiveItemId } = useActiveNavItem(filteredNavigation);

  // Get the active ID (either explicit or inferred)
  const currentActiveId = activeNavItemId ?? getActiveItemId();
  const isActive = currentActiveId === item.id;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    // Only remove focus for actual mouse clicks (e.detail > 0)
    // Keyboard activations (space/enter) have e.detail === 0 and should retain focus
    if (e.detail > 0) {
      (e.currentTarget as HTMLElement).blur();
    }
    navigate(item);
  };

  const homeIconSrc = navIconMap.home;
  
  return (
    <NavHomeButton
      aria-label="Home"
      aria-current={isActive ? 'page' : undefined}
      onClick={handleClick}
      sx={{
        backgroundColor: isActive ? NAV_HOVER_BG_MAIN : 'transparent',
      }}
    >
      <NavIconImage src={homeIconSrc} />
      <NavText
        noWrap
        sx={{
          opacity: isNavOpen ? 1 : 0,
          transition: 'opacity 200ms',
          fontSize: '0.9375rem',
        }}
      >
        {item.label}
      </NavText>
    </NavHomeButton>
  );
};
